module.exports = __webpack_public_path__ + "static/media/cover-1.cea49311.jpg";